export { default } from './ViewCompositionSamples';
